import { cn } from "@/lib/utils";

function BentoGrid({ items }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 max-w-7xl mx-auto">
      {items.map((item, index) => (
        <div
          key={index}
          className={cn(
            "group relative p-8 md:p-10 liquid-glass rounded-[2rem] overflow-hidden transition-all duration-300",
            "border border-white/10",
            "hover:shadow-[0_2px_12px_rgba(255,255,255,0.03)]",
            "hover:-translate-y-0.5 will-change-transform",
            item.colSpan === 2 ? "md:col-span-2" : "col-span-1",
            {
              "shadow-[0_2px_12px_rgba(255,255,255,0.03)] -translate-y-0.5":
                item.hasPersistentHover,
            }
          )}
        >
          {/* Dot pattern overlay */}
          <div
            className={`absolute inset-0 ${
              item.hasPersistentHover
                ? "opacity-100"
                : "opacity-0 group-hover:opacity-100"
            } transition-opacity duration-300`}
          >
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[length:4px_4px]" />
          </div>

          <div className="relative flex flex-col space-y-3">
            {/* Header: icon + status */}
            <div className="flex items-center justify-between">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-white/10 group-hover:bg-gradient-to-br group-hover:from-white/10 group-hover:to-white/5 transition-all duration-300">
                {item.icon}
              </div>
              {item.status && (
                <span
                  className={cn(
                    "text-xs font-medium px-2.5 py-1 rounded-lg backdrop-blur-sm",
                    "bg-white/10 text-gray-300",
                    "transition-colors duration-300 group-hover:bg-white/20"
                  )}
                >
                  {item.status}
                </span>
              )}
            </div>

            {/* Title + description */}
            <div className="space-y-2">
              <h3 className="font-medium text-gray-100 tracking-tight text-[15px]">
                {item.title}
                {item.meta && (
                  <span className="ml-2 text-xs text-gray-400 font-normal">
                    {item.meta}
                  </span>
                )}
              </h3>
              <p className="text-sm text-gray-300 leading-snug font-light">
                {item.description}
              </p>
            </div>

            {/* Tags + CTA */}
            <div className="flex items-center justify-between mt-2">
              <div className="flex items-center flex-wrap gap-1.5 text-xs text-gray-400">
                {item.tags?.map((tag, i) => (
                  <span
                    key={i}
                    className="px-2 py-1 rounded-md bg-white/10 backdrop-blur-sm transition-all duration-200 hover:bg-white/20"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
              <span className="text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity shrink-0 ml-2">
                {item.cta || "Explore →"}
              </span>
            </div>
          </div>

          {/* Gradient border */}
          <div
            className={`absolute inset-0 -z-10 rounded-2xl p-px bg-gradient-to-br from-transparent via-white/10 to-transparent ${
              item.hasPersistentHover
                ? "opacity-100"
                : "opacity-0 group-hover:opacity-100"
            } transition-opacity duration-300`}
          />
        </div>
      ))}
    </div>
  );
}

export { BentoGrid };
